import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { BrandLogo } from "@/components/site/BrandLogo";

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="border-t border-clan-ink/10 bg-clan-bg py-14">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-center lg:px-10">
        <div className="flex flex-col items-start gap-3">
          <BrandLogo size="footer" />
          <p className="max-w-xs text-sm text-clan-muted">{t.footer.tagline}</p>
          <div className="mt-1 flex flex-wrap gap-x-5 gap-y-1">
            <Link
              to="/notable"
              data-testid="footer-notable-link"
              className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-clan-accent transition-colors duration-300 hover:text-clan-ink"
            >
              {t.notable.link} →
            </Link>
            <Link
              to="/recipes"
              data-testid="footer-recipes-link"
              className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-clan-accent transition-colors duration-300 hover:text-clan-ink"
            >
              {t.recipes?.nav || "Recipes"} →
            </Link>
            <Link
              to="/events"
              data-testid="footer-events-link"
              className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-clan-accent transition-colors duration-300 hover:text-clan-ink"
            >
              Events →
            </Link>
          </div>
        </div>

        <div className="text-left md:text-right">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-clan-accent">Per mare per terras</p>
          <p className="mt-2 text-xs text-clan-muted">© {new Date().getFullYear()} · {t.footer.rights}</p>
          <p className="mt-1 text-xs text-clan-muted/60">{t.footer.builtWith}</p>
        </div>
      </div>
    </footer>
  );
}
